import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';

import { setModoTela, initForm } from './usuarioActions';
import labelAndInputMask from '../common/form/labelAndInputMask';
import ClienteUtils from '../common/utils/ClienteUtils';

class UsuarioForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail *'
								placeholder='Informe o E-mail'
								cols='12 12 12 12'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />

							{!this.props.configuracao &&
							<Field
								name='senha'
								component={LabelAndInput}
								type="password"
								label='Senha *'
								placeholder='Informe a Senha'
								cols='12 12 12 12'
								readOnly={readOnly} />}

						</Row>
						{(this.props.configuracao || !this.props.formularioValues.id) &&
						<Row>
							<Grid cols='12 12 12 12'>
								<label>Permissões de Acesso</label>
							</Grid>

							<Field
								cols='6 4 3 2'
								name='acesso_cadastro_usuario'
								component={LabelAndCheckbox}
								label='Usuário'
								placeholder='Selecione'
								readOnly={readOnly} />							
							
							<Field
								cols='6 4 3 2'
								name='acesso_cadastros'
								component={LabelAndCheckbox}
								label='Cadastro'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								cols='6 4 3 2'
								name='acesso_contratos'
								component={LabelAndCheckbox}
								label='Contrato'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								cols='6 4 3 2'
								name='acesso_producoes'
								component={LabelAndCheckbox}
								label='Produção'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								cols='6 4 3 2'
								name='acesso_despesas'
								component={LabelAndCheckbox}
								label='Despesa'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								cols='6 4 3 2'
								name='acesso_relatorios'
								component={LabelAndCheckbox}
								label='Relatório'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>}

						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UsuarioForm = reduxForm({form: 'usuarioForm', destroyOnUnmount: false})(UsuarioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioForm')(state),
	registro: state.usuario.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);
